/* =====================================================
   ORDER GROUP POPUP
===================================================== */

(function () {

    if (document.getElementById("order-group-overlay")) return;

    const popup = `
    <div id="order-group-overlay">

        <div id="order-group-popup">

            <h2>Collection Restriction</h2>

            <p>
                Your cart already contains products from
            </p>

            <div class="collection-name" id="popup-order-group-name">
            </div>

            <p>
                Kindly note that the minimum purchase requirement applies to each collection individually.
            </p>

            <p>
                You can submit your order from this collection first and then continue shopping from other collections.
            </p>

            <p class="thank-you">
                Thank you.
            </p>

            <div class="order-popup-buttons">

                <button
                    id="order-popup-close"
                    type="button">

                    Close

                </button>

                <button
                    id="order-popup-cart"
                    type="button">

                    View Cart

                </button>

            </div>

        </div>

    </div>
    `;
  function renderPopup() {

      if (!document.getElementById("order-group-overlay")) {
          document.body.insertAdjacentHTML("beforeend", popup);
      }

  }

if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", renderPopup);

} else {

    renderPopup();

}
})();
/* =====================================================
   POPUP FUNCTIONS
===================================================== */

window.showOrderGroupPopup = function (collectionName) {

    const overlay = document.getElementById("order-group-overlay");

    if (!overlay) return;

    const name = document.getElementById("popup-order-group-name");

    if (name) {
        name.textContent = collectionName;
    }

    overlay.style.display = "flex";

    document.getElementById("order-popup-close").focus();

    document.body.style.overflow = "hidden";
};

window.hideOrderGroupPopup = function () {

    const overlay = document.getElementById("order-group-overlay");

    if (!overlay) return;

    overlay.style.display = "none";

    document.body.style.overflow = "";

};


/* =====================================================
   EVENT LISTENERS
===================================================== */

document.addEventListener("click", function (event) {

    // Close Button
    if (event.target.id === "order-popup-close") {

        hideOrderGroupPopup();
        return;

    }

    // View Cart
    if (event.target.id === "order-popup-cart") {

        window.location.href = "/cart";
        return;

    }

    // Click Outside Popup
    if (event.target.id === "order-group-overlay") {

        hideOrderGroupPopup();
        return;

    }

});


// ESC Key
document.addEventListener("keydown", function (event) {

    if (event.key === "Escape") {

        hideOrderGroupPopup();

    }

});
/* =====================================================
   ORDER GROUP VALIDATOR
===================================================== */

window.validateOrderGroup = async function (currentOrderGroup) {

    if (!currentOrderGroup) {
        return {
            success: true
        };
    }

    try {

        const cart = await fetch('/cart.js').then(r => r.json());

        if (!cart.items.length) {
            return {
                success: true
            };
        }

        const existingGroups = [
            ...new Set(
                cart.items
                    .map(item => item.properties?.order_group)
                    .filter(Boolean)
            )
        ];

        if (!existingGroups.length) {
            return {
                success: true
            };
        }

        if (existingGroups.includes(currentOrderGroup)) {
            return {
                success: true
            };
        }

        return {
            success: false,
            cartOrderGroup: existingGroups[0]
        };

    } catch (e) {

        console.error(e);

        return {
            success: true
        };

    }

};